/** Why a receiving-kiosk control is disabled, shown when the operator taps it. */

export const INBOUND_RECEIVE_FINISHED_CRATE_TAP = "This arrival crate is already finished.";

export function inboundReceiveSealTapReason(input: {
  controlsBusy: boolean;
  sealReady: boolean;
  sealBlockReason: string | null;
}): string | null {
  if (input.controlsBusy || input.sealReady) return null;
  return input.sealBlockReason;
}

export function inboundReceiveReprintTapReason(input: {
  busy: boolean;
  labelPrinterSelected: boolean;
}): string | null {
  if (input.busy || input.labelPrinterSelected) return null;
  return "Select a 4x2 label printer in the header.";
}

export function inboundReceiveUnsealTapReason(input: {
  busy: boolean;
  itemCount: number;
}): string | null {
  if (input.busy) return null;
  if (input.itemCount <= 0) return "This container has no lines to unseal.";
  return null;
}

export function inboundReceiveDamagedTapReason(input: {
  receiptReadOnly: boolean;
  hasScannedArrivalPackage: boolean;
  exceptionPending: boolean;
}): string | null {
  if (input.exceptionPending) return null;
  if (input.receiptReadOnly) return INBOUND_RECEIVE_FINISHED_CRATE_TAP;
  if (!input.hasScannedArrivalPackage) {
    return "Scan the dock crate tag before marking a line damaged.";
  }
  return null;
}

export function inboundReceiveClearLineTapReason(input: {
  receiptReadOnly: boolean;
  openQuantity: number;
}): string | null {
  if (input.receiptReadOnly) return INBOUND_RECEIVE_FINISHED_CRATE_TAP;
  if (input.openQuantity <= 0) return "This line has no open quantity to clear.";
  return null;
}

export function inboundReceiveNumpadTapReason(input: {
  receiptReadOnly: boolean;
  lineSelected: boolean;
  mpnAllowsCounting: boolean;
  closePending: boolean;
}): string | null {
  if (input.closePending) return null;
  if (input.receiptReadOnly) return INBOUND_RECEIVE_FINISHED_CRATE_TAP;
  if (!input.lineSelected) return "Tap a line before counting quantity.";
  if (!input.mpnAllowsCounting) {
    return "Enter the manufacturer part number before counting this line.";
  }
  return null;
}

export function inboundReceiveLineTileTapReason(input: {
  receiptReadOnly: boolean;
  closePending: boolean;
}): string | null {
  if (input.closePending) return null;
  if (input.receiptReadOnly) return INBOUND_RECEIVE_FINISHED_CRATE_TAP;
  return null;
}

export function inboundReceiveMoreActionsTapReason(input: {
  receiptReadOnly: boolean;
  busy: boolean;
}): string | null {
  if (input.busy) return null;
  if (input.receiptReadOnly) return INBOUND_RECEIVE_FINISHED_CRATE_TAP;
  return null;
}
